import { getLocationPointWithGuessedType } from '@commons/models/LocationPoint';
import fetchArea from '@location/actions/fetchArea';
import { SELECTION_TYPE } from '@commons/models/LocationPoint/constants';
import setSelectionType from '@commons/models/LocationPoint/setters/setSelectionType';
import { LOCATION_POINT_TYPE } from '@location/constants';
import getSearchedLocationWithCity from './getSearchedLocationWithCity';

const setSearchedLocation = (
  newLocation,
  { saveSync = false, selectionType = SELECTION_TYPE.SELECTED } = {},
) => async dispatch => {
  const locationToBeSaved = newLocation;

  if (
    locationToBeSaved.type === LOCATION_POINT_TYPE.USER_ADDRESS &&
    !locationToBeSaved?.area
  ) {
    locationToBeSaved.area = await dispatch(fetchArea(newLocation));
  }

  // In case we try to save location without type, we try to guess it,
  // despite it should not happen.
  const newPoint = await dispatch(
    getSearchedLocationWithCity({
      newLocation: getLocationPointWithGuessedType(locationToBeSaved),
      saveSync,
    }),
  );

  setSelectionType(selectionType);

  return newPoint;
};

export default setSearchedLocation;
